module.exports = __webpack_public_path__ + "img/art6-img1.4879a4e6.jpeg";